<template>
  <div class="scroll-section">
    <div class="bg-gradient"></div>
    <transition @enter="fadeIn" @leave="fadeOut" :css="false">
      <div class="sun-gradient animate" v-show="!buildingActive"></div>
    </transition>
    <div class="bg-clouds animate">
      <div :class="'cloud_'+n"v-for="n in 3" :key="'cloud_animate_' + n">
        <svg version="1.1" viewBox="0 0 480 200">
          <path class="cloud-path" d="M2.6,149.2c0,0,29.7,64.1,184.4,29.3c0,0,57.2,31.2,101.7-5.5c0,0,120.8,22,169.5-3.7s-8.5-77-46.6-71.5c0,0-12.7-51.3-80.5-31.2c0,0-27.5-55-101.7-56.8C122.7,7.3,81,83.2,81,83.2S-5.8,99.7,2.6,149.2z" />
        </svg>
      </div>
    </div>
    <transition @enter="fadeIn" @leave="fadeOut" :css="false">
    <header class="city-header animate" v-show="!cityZoomed">
      <div class="city-header-inner">
        <h4 style="margin-top:-30px;margin-bottom:5px;">{{ $t('city.welcome') }}</h4>
        <h1 class="hero">Online<strong>city</strong></h1>
      </div>
    </header>
    </transition>
    <div class="city animate">
      <div class="city-inner">
        <div class="city-bg" :style="'background-image: url('+ city_bg_img +');'"></div>
        <transition @enter="fadeIn" @leave="fadeOut" :css="false">
          <div class="city-overlay" v-show="buildingActive" :style="'background-image: url('+ city_overlay_img +');'"></div>
        </transition>
        <div class="buildings">
          <div class="building" :key="'building' + idx" v-for="(building, idx) in buildings" @click="showBuildingInfo(building, true)" @mouseenter="showBuildingInfo(building, false)" @mouseleave="hideBuildingInfo(building, false)" :class="[{ 'is-active': building.isActive}, building.nameClass]" :style="'background-image: url('+building.bg+')'">
            <div class="tower-display animate" v-if="building.nameClass === 'geek'">
              <img class="tower-display-img" :src="towerText">
            </div>
            <div class="relation-bridge" v-if="building.nameClass === 'relation'">
              <div class="bridge-bg">
                <div class="bg-img" :style="'background-image: url('+ relBgImg +')'"></div>
              </div>
            </div>
            <div class="tl-animated-elements">
              <div v-show="(building.isActive && el.hoverAnimation) || (el.alwaysOn && !el.hoverAnimation)" :class="el.nameClassArr"
                :key="'tl-animated-elements' + idx"
                v-for="(el, idx) in building.animatedElements">
                <div v-if="el.img" class="el-img" :class="'_'+idx">
                  <img :src="el.img">
                </div>
              </div>
            </div>
            <div class="relation-bridge" v-if="building.nameClass === 'relation'">
              <div class="bridge-fg">
                <div class="fg-img" :style="'background-image: url('+ relFgImg +')'"></div>
              </div>
            </div>
            <transition @enter="fadeIn" @leave="fadeOut" :css="false">
              <div class="building-overlay" v-show="buildingActive && !building.isActive" :style="'background-image: url('+building.overlay+')'"></div>
            </transition>
            <transition @enter="fadeInUp" @leave="hide" :css="false">
              <div class="building-desc" v-show="building.isActive">
                <h1 class="animate" v-html="$t('city.building_descriptions['+idx+'].headline')"></h1>
                <div class="animate" v-html="$t('city.building_descriptions['+idx+'].desc')"></div>
                <a v-if="building.showComeOnIn" class="animate" :href="$t('city.building_descriptions['+idx+'].btn_link')">{{  $t('city.building_descriptions['+idx+'].btn_text') }}</a>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <div class="tip">
      </div>
    </div>
    <!--
    <div class="plane" :style="'background-image: url('+ plane_img +');'">
      <div class="banner">
        <div class="left"></div>
        <div class="middle">{{ $t('city.banner_text') }}</div>
        <div class="tail"></div>
      </div>
    </div>-->
      <div class="mobile-building-texts" v-show="cityZoomed">
        <transition-group @enter="fadeIn" @leave="fadeOut" :css="false" tag="div" class="mobile-building-texts-inner">
        <div class="building-text"
          :key="'building-text' + idx"
          v-for="(building, idx) in buildings"
          v-show="building.isActive && cityZoomed">
          <h1 v-html="$t('city.building_descriptions['+idx+'].headline')"></h1>
          <div v-html="$t('city.building_descriptions['+idx+'].desc_short')"></div>
          <a :href="$t('city.building_descriptions['+idx+'].btn_link')">{{  $t('city.building_descriptions['+idx+'].btn_text') }}</a>
        </div>
        </transition-group>
      </div>
    <div class="mobile-close" v-show="cityZoomed" @click="cityZoomed = false"></div>
  </div>
</template>

<script>
import cityBg from '../.././assets/city-bg-optimized.png';
import cityOverlay from '../.././assets/city-overlay-optimized.png';

import nexconBg from '../.././assets/building-bg__nexcon.png'
import nexconOverlay from '../.././assets/building-overlay__nexcon.png'

import geekBg from '../.././assets/building-bg__geek-optimized-new-logo.png'
import geekOverlay from '../.././assets/building-overlay__geek.png'

import relationBg from '../.././assets/building-bg__relation.png'
import relationOverlay from '../.././assets/building-overlay__relation.png'

import rBgImg from '../.././assets/bridge-bg.png'
import rFgImg from '../.././assets/bridge-fg.png'

import bridgePpl1 from '../.././assets/bridge-ppl-1.svg'
import bridgePpl2 from '../.././assets/bridge-ppl-2.svg'
import bridgePpl3 from '../.././assets/bridge-ppl-3.svg'
import bridgePpl4 from '../.././assets/bridge-ppl-4.svg'
import bridgePpl5 from '../.././assets/bridge-ppl-5.svg'
import bridgePpl6 from '../.././assets/bridge-ppl-6.svg'

import displayText from '../.././assets/tower-display.png'

import planeImg from '../.././assets/plane.png'

import { mapGetters, mapActions } from 'vuex'

import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';

export default {
  name: 'City',
  data () {
    return {
      exclude_from_nav: false,
      nav_title: 'onlinecity',
      animationsDone: false,
      animationsInit: false,
      // component specific data
      buildingActive: false,
      activeBuildingName: null,
      city_bg_img: cityBg,
      city_overlay_img: cityOverlay,
      plane_img: planeImg,
      towerText: displayText,
      lastActiveBuilding: '',
      cityZoomed: false,
      relBgImg: rBgImg,
      relFgImg: rFgImg,
      // Building data
      buildings: [
        {
          // livebackend
          timelines: {
            action: null,
            subtle: null
          },
          nameClass: 'party',
          bg: nexconBg,
          overlay: nexconOverlay,
          isActive: false,
          showComeOnIn: true,
          animatedElements: [
            {
              nameClassArr: ['beam', 'yellow'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['beam', 'blue'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['beam', 'green'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['beam', 'red'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['lamp', 'yellow'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['lamp', 'blue'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['lamp', 'green'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['lamp', 'red'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['lamp', 'green_2'],
              hoverAnimation: false,
              alwaysOn: true
            }
          ]
        }, {
          // gatewayapi
          timelines: {
            action: null,
            subtle: null
          },
          nameClass: 'geek',
          bg: geekBg,
          overlay: geekOverlay,
          isActive: false,
          showComeOnIn: true,
          animatedElements: [
            {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['ug-led'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['wave'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['wave'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['wave'],
              hoverAnimation: true,
              alwaysOn: false
            }
          ]
        }, {
          // relationcity
          timelines: {
            action: null,
            subtle: null
          },
          nameClass: 'relation',
          bg: relationBg,
          overlay: relationOverlay,
          isActive: false,
          showComeOnIn: true,
          animatedElements: [
            {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl1
            }, {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl2
            }, {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl3
            }, {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl4
            }, {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl5
            }, {
              nameClassArr: ['bridge-ppl'],
              hoverAnimation: false,
              alwaysOn: true,
              img: bridgePpl6
            }, {
              nameClassArr: ['crane-hook'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['worker', 'scaffolding-lower-1'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['worker', 'scaffolding-lower-2'],
              hoverAnimation: false,
              alwaysOn: true
            }, {
              nameClassArr: ['worker', 'crane-1'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['worker', 'crane-2'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['window'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['window'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['window'],
              hoverAnimation: true,
              alwaysOn: false
            }, {
              nameClassArr: ['window'],
              hoverAnimation: true,
              alwaysOn: false
            }
          ]
        }
      ]
    }
  },

  mounted () {
    if (this.curSection === this.$options._componentTag) {
      this.runSectionAnimations()
    }
    this.hideElements()
    this.addBuildingTimelines()
  },

  watch: {
    buildingActive (val) {
      let ugLED = this.$el.querySelectorAll('.ug-led')
      TweenMax.set(ugLED, {
        autoAlpha: !val
      })
    },
    cityZoomed (val) {
      if (!val) {
        this.setScrollLockedState(false)
        this.buildingActive = false
        for (let i = 0; i < this.buildings.length; i++) {
          this.buildings[i].isActive = false
        }
        TweenMax.to('.passion-texts', 0.8, {
          autoAlpha: 1,
          delay: 0.8,
          ease: Power3.easeInOut
        })
        let city = this.$el.querySelector('.city')
        TweenMax.to(city, 0.7, {
          scale: 1,
          ease: Power3.easeInOut
        })
      }
    },
    activeBuildingName (val) {
      for (let i = 0; i < this.buildings.length; i++) {
        if (val === this.buildings[i].nameClass || val === 'none') {
          this.buildings[i].timelines.subtle.play()
          if (val === 'geek') {
            this.buildings[i].timelines.subtle.pause()
          }
        } else {
          this.buildings[i].timelines.subtle.pause()
        }
      }
    },
    curSection (val) {
      if (this.curSection === this.$options._componentTag) {
        this.runSectionAnimations()
      }
    },
    scroll_pos (val) {
      if (this.scroll_pos > (this.$el.offsetTop + 100) && this.scroll_pos < ((this.elHeight - 200) + this.$el.offsetTop)) {
        if (!this.is_animating_scroll) {
          this.runSectionAnimations()
          this.setActiveSection(this.$options._componentTag)
        }
      }
    }
  },

  computed: {
    ...mapGetters({
      curSection: 'getActiveSection',
      scroll_pos: 'getScrollPos',
      is_animating_scroll: 'getAnimatingScrollState'
    }),
    elHeight () {
      return Math.ceil(this.$el.getBoundingClientRect().height)
    }
  },

  methods: {
    ...mapActions([
      'setActiveSection',
      'setScrollLockedState'
    ]),
    zoomCity (building, active) {
      let city = this.$el.querySelector('.city')
      let origin = 'top'
      switch (building.nameClass) {
        case 'party' :
          origin = 'left top'
          break
        case 'geek' :
          origin = 'center top'
          break
        case 'relation' :
          origin = 'right top'
          break
      }
      TweenMax.set('.passion-texts', {
        autoAlpha: 0
      })
      TweenMax.to(city, 0.7, {
        transformOrigin: origin,
        scale: 1.8,
        ease: Power3.easeInOut
      })
      this.lastActiveBuilding = building
      this.cityZoomed = true
    },
    getRandomArbitrary (min, max) {
      return Math.random() * (max - min) + min
    },
    hideElements () {
      let elements = this.$el.querySelectorAll('.animate')
      TweenMax.set(elements, {
        autoAlpha: 0
      })
      let bText = this.$el.querySelector('.building-text')
      TweenMax.set(bText, {
        autoAlpha: 0
      })
    },
    addBuildingTimelines () {
      // party mouseenter animation
      this.buildings[0].timelines.action = new TimelineMax({
        repeat: -1,
        yoyo: true
      })
      let beamBlue = this.$el.querySelector('.beam.blue')
      let beamRed = this.$el.querySelector('.beam.red')
      let beamYellow = this.$el.querySelector('.beam.yellow')
      let beamGreen = this.$el.querySelector('.beam.green')
      this.buildings[0].timelines.action.to(beamBlue, 1, {
        rotation: '60deg',
        ease: Power3.easeInOut
      }).to(beamRed, 1, {
        rotation: '-60deg',
        ease: Expo.easeInOut
      }, 0).to(beamYellow, 1, {
        rotation: '-40deg',
        ease: Power4.easeInOut
      }, 0).to(beamGreen, 1, {
        rotation: '40deg',
        ease: Power1.easeInOut
      }, 0)
      this.buildings[0].timelines.action.pause()

      // party subtle animation, flashes lamps on and off
      this.buildings[0].timelines.subtle = new TimelineMax({
        repeat: -1,
        yoyo: true,
        delay: 0.2
      })
      let lampBlue = this.$el.querySelector('.lamp.blue')
      let lampRed = this.$el.querySelector('.lamp.red')
      let lampYellow = this.$el.querySelector('.lamp.yellow')
      let lampGreen = this.$el.querySelector('.lamp.green')
      let lampGreen2 = this.$el.querySelector('.lamp.green_2')
      this.buildings[0].timelines.subtle.fromTo(lampBlue, 0.5, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        ease: Power3.easeInOut
      }, 0).fromTo(lampRed, 0.5, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: Expo.easeInOut
      }, 0).fromTo(lampYellow, 0.5, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        ease: Power4.easeInOut
      }, 0).fromTo(lampGreen, 0.5, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: Power4.easeInOut
      }, 0).fromTo(lampGreen2, 0.5, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: Power4.easeInOut
      }, 0)
      this.buildings[0].timelines.subtle.pause()

      // geek subtle
      let waves = this.$el.querySelectorAll('.wave')
      this.buildings[1].timelines.subtle = new TimelineMax({
        repeat: -1,
        repeatDelay: 0.5
      })
      this.buildings[1].timelines.subtle.staggerTo(waves, 0.2, {
        autoAlpha: 1,
        ease: Power4.easeInOut
      }, 0.2)
      let ugLEDs = this.$el.querySelectorAll('.ug-led')
      ugLEDs.forEach((LED) => {
        this.buildings[1].timelines.subtle.to(LED, 0.2, {
          autoAlpha: 0
        }, this.getRandomArbitrary(0.1, 0.5)).to(LED, 0.2, {
          autoAlpha: 1
        })
      })


      // geek action
      let infoTextWrapper = this.$el.querySelector('.tower-display')
      let infoText = this.$el.querySelector('.tower-display-img')
      this.buildings[1].timelines.action = new TimelineMax({
        repeat: -1,
        repeatDelay: 0.5
      })
      this.buildings[1].timelines.action.to(infoTextWrapper, 0.2, {
        autoAlpha: 1
      }, 0).to(infoText, 6, {
        x: -700,
        ease: TweenMax.SteppedEase.config(40)
      }, 0.2)
      this.buildings[1].timelines.action.pause()

      // relations subtle
      let worker1 = this.$el.querySelector('.scaffolding-lower-1')
      let worker2 = this.$el.querySelector('.scaffolding-lower-2')
      this.buildings[2].timelines.subtle = new TimelineMax({
        repeat: -1,
        yoyo: true
      })
      this.buildings[2].timelines.subtle.fromTo(worker1, 1.5, {
        x: -10,
        y: -5
      }, {
        x: 0,
        y: 0,
        ease: TweenMax.SteppedEase.config(5)
      }, 'workerWalk').fromTo(worker2, 1.2, {
        x: -10,
        y: -5
      }, {
        x: 0,
        y: 0,
        ease: TweenMax.SteppedEase.config(6)
      })
      let bridgePpl1 = this.$el.querySelector('.el-img._1')
      this.buildings[2].timelines.subtle.to(bridgePpl1, 6, {
        x: 220,
        y: 3,
        ease: Power0.easeNone
      }, 'workerWalk+=0').set(bridgePpl1, {
        rotationY: 180
      }).to(bridgePpl1, 4, {
        x: 0,
        y: 0,
        ease: Power0.easeNone
      }).set(bridgePpl1, {
        rotationY: 0
      })
      let bridgePpl2 = this.$el.querySelector('.el-img._2')
      this.buildings[2].timelines.subtle.to(bridgePpl2, 5, {
        x: 220,
        y: 3,
        ease: Power0.easeNone
      }, 'workerWalk+=1').set(bridgePpl2, {
        rotationY: 180
      }).to(bridgePpl2, 4, {
        x: 0,
        y: 0,
        ease: Power0.easeNone
      }).set(bridgePpl2, {
        rotationY: 0
      })
      let bridgePpl3 = this.$el.querySelector('.el-img._3')
      this.buildings[2].timelines.subtle.to(bridgePpl3, 5, {
        x: 220,
        y: 3,
        ease: Power0.easeNone
      }, 'workerWalk+=3').set(bridgePpl3, {
        rotationY: 180
      }).to(bridgePpl3, 4, {
        x: 0,
        y: 0,
        ease: Power0.easeNone
      }).set(bridgePpl3, {
        rotationY: 0
      })
      let bridgePpl4 = this.$el.querySelector('.el-img._4')
      this.buildings[2].timelines.subtle.fromTo(bridgePpl4, 5.5, {
        x: 220,
        y: 3
      }, {
        x: 0,
        y: 0,
        ease: Power0.easeNone
      }, 'workerWalk+=4').set(bridgePpl4, {
        rotationY: 180
      }).to(bridgePpl4, 4, {
        x: 0,
        y: 0,
        ease: Power0.easeNone
      }).set(bridgePpl4, {
        rotationY: 0
      })
      this.buildings[2].timelines.subtle.pause()

      // relations action
      this.buildings[2].timelines.action = new TimelineMax({
        repeat: -1
      })
      let worker3 = this.$el.querySelector('.crane-2')
      let craneHook = this.$el.querySelector('.crane-hook')
      let windows = this.$el.querySelectorAll('.window')
      this.buildings[2].timelines.action.staggerFromTo(windows, 0.2, {
        autoAlpha: 0
      }, {
        autoAlpha: 1,
        ease: Power0.easeNone
      }, 0.8).to(craneHook, 1.5, {
        height: '41px',
        ease: Power0.easeNone
      }).to(worker3, 0.2, {
        y: -7,
        ease: Power0.easeNone
      }).to(worker3, 0.2, {
        y: 0,
        ease: Power0.easeNone
      }).to(worker3, 0.2, {
        y: -7,
        ease: Power0.easeNone
      }).to(worker3, 0.2, {
        y: 0,
        ease: Power0.easeNone
      }).to(craneHook, 1.2, {
        height: '4px',
        ease: Power0.easeNone,
      })
      this.buildings[2].timelines.action.pause()
    },

    // Initiated when city entry animation is done (onComplete)
    playSubtleBuildingAnimations () {
      for (let i = 0; i < this.buildings.length; i++) {
        this.buildings[i].timelines.subtle.play()
      }
    },
    moveClouds () {
      let cloud1 = this.$el.querySelectorAll('.cloud_1')
      let cloud2 = this.$el.querySelectorAll('.cloud_2')
      let cloud3 = this.$el.querySelectorAll('.cloud_3')
      let cloudsWrapper = this.$el.querySelectorAll('.bg-clouds')
      TweenMax.to(cloudsWrapper, 0.3, {
        autoAlpha: 1
      })

      /*
      let plane = this.$el.querySelector('.plane')
      let planeTimeline = new TimelineMax({
        repeat: 0
      })
      planeTimeline.to(plane, 6, {
        x: -Math.abs(window.innerWidth),
        y: -60,
        ease: Power1.easeInOut
      }).to(plane, 0.5, {
        autoAlpha: 0
      }, 5)

      */

      let cloudTimeline1 = new TimelineMax({
        repeat: -1
      })
      cloudTimeline1.fromTo(cloud1, 41, {
        x: -400
      }, {
        x: window.innerWidth,
        ease: Power0.easeNone
      })
      cloudTimeline1.seek(32)

      let cloudTimeline2 = new TimelineMax({
        repeat: -1
      })
      cloudTimeline2.fromTo(cloud2, 34, {
        x: -400
      }, {
        x: window.innerWidth,
        ease: Power0.easeNone
      })
      cloudTimeline2.seek(21)

      let cloudTimeline3 = new TimelineMax({
        repeat: -1
      })
      cloudTimeline3.fromTo(cloud3, 31, {
        x: -400
      }, {
        x: window.innerWidth,
        ease: Power0.easeNone
      })
      cloudTimeline2.seek(6)
    },
    runSectionAnimations () {
      if (this.animationsDone || this.animationsInit) return

      let _this = this

      let mainTimeline = new TimelineMax({
        repeat: 0,
        delay: 1,
        onComplete () {
          _this.animationsDone = true
          _this.playSubtleBuildingAnimations()
          if (window.innerWidth > 1024) {
            _this.moveClouds()
          }
        }
      })
      let city = this.$el.querySelector('.city')
      let sunGradient = this.$el.querySelector('.sun-gradient')
      let cityHeader = this.$el.querySelector('.city-header')

      mainTimeline.fromTo(cityHeader, 1.5, {
        autoAlpha: 0,
        y: 200,
        ease: Power4.easeOut
      }, {
        autoAlpha: 1,
        y: 0
      }, 0.6).to(city, 0.8, {
        autoAlpha: 1,
        ease: Power4.easeOut
      }, 0.4).fromTo(city, 1.2, {
        y: 90
      }, {
        y: 0,
        ease: Power1.easeOut
      }, 0.4).fromTo(sunGradient, 1.1, {
        autoAlpha: 0,
        y: 90,
        x: '-50%'
      }, {
        autoAlpha: 1,
        y: 0,
        x: '-50%'
      }, 0.4).fromTo(sunGradient, 2.3, {
        scale: 0.7,
        transformOrigin: 'center'
      }, {
        scale: 1,
        ease: Power1.easeIn
      }, 0.6)

      this.animationsInit = true
    },

    /**
     * Buildings' hover states
     * -----------------------------------------------------------
    */
    hideBuildingInfo (building, tap) {
      if (!this.animationsDone || window.innerWidth < 769) return
      this.buildingActive = false
      building.isActive = false
      this.activeBuildingName = 'none'
      building.timelines.action.pause()
    },
    showBuildingInfo (building, tap) {
      if (!this.animationsDone) return
      if (window.innerWidth < 769 && !tap) return
      if (window.innerWidth > 769 && tap) return
      if (tap) {
        this.setScrollLockedState(true)
        this.zoomCity(building, true)
      }
      this.buildingActive = true
      this.activeBuildingName = building.nameClass
      for (let i = 0; i < this.buildings.length; i++) {
        if (this.buildings[i].nameClass === building.nameClass) {
          this.buildings[i].isActive = true
        } else {
          this.buildings[i].isActive = false
        }
      }
      building.timelines.action.play()
    },

    /**
     * Animations
     * -----------------------------------------------------------
    */
    fadeInUp (el, done) {
      let els = el.querySelectorAll('.animate')
      TweenMax.set(els, {
        y: 40,
        autoAlpha: 0
      })
      TweenMax.set(el, {
        autoAlpha: 1
      })
      TweenMax.staggerTo(els, 1, {
        autoAlpha: 1,
        y: -20,
        delay: 0.2,
        ease: Power3.easeOut
      }, 0.07)
    },
    hide (el, done) {
      let els = el.querySelectorAll('.animate')
      TweenMax.set(el, {
        autoAlpha: 0
      })
      TweenMax.set(els, {
        autoAlpha: 0
      })
    },
    fadeIn (el, done) {
      TweenMax.to(el, 0.9, {
        autoAlpha: 1,
        ease: Power3.easeOut
      })
    },
    fadeOut (el, done) {
      TweenMax.to(el, 0.15, {
        autoAlpha: 0
      })
    }
  }
}
</script>

<style lang="postcss">
  .bg-gradient {
    background: ease-out-sine-gradient(
      #d5edef,
      transparent
    );
  }
  .mobile-building-texts {
    background: ease-out-sine-gradient(
      transparent,
      #9cbad1
    );
  }
</style>

<style lang="scss" scoped>
  @import '../.././assets/variables';
  .scroll-section {
    padding-top: 500px;
    padding-bottom: 81px;
    background-color: $city_bg;
    overflow: hidden;
    position: relative;
    @media screen and (max-width: 768px) {
      overflow: visible;
      z-index: 2;
      padding-top: 38%;
      padding-bottom: 10%;
    }
    @media screen and (max-width: 480px) {
      padding-top: 60%;
      padding-bottom: 15%;
    }
  }
</style>

<style lang="scss">
@import '../.././assets/variables';

.sun-gradient {
  width: 100%;
  height: 60%;
  min-height: 660px;
  position: absolute;
  left: 50%;
  top: 330px;
  transform: translateX(-50%);
  background: radial-gradient( ellipse at center,
  rgba(248, 203, 92, 1) 13%,
  rgba(250, 218, 115, .8) 19%,
  rgba(255, 254, 171, 0.5) 34%,
  rgba(252, 247, 201, 0) 70%);
  @media screen and (max-width: 768px) {
    top: 160px;
    height: 440px;
    min-height: 0;
  }
  @media screen and (max-width: 480px) {
    top: 160px;
    height: 220px;
    min-height: 0;
  }
}

.mobile-close {
  position: absolute;
  top: 100px;
  right: 20px;
  width: 34px;
  height: 34px;
  z-index: 900;
  &:before, &:after {
    content: '';
    position: absolute;
    height: 2px;
    width: 100%;
    top: 50%;
    left: 0;
    margin-top: -1px;
    border-radius: 2px;
    background: #000;
  }
  &:before {
    transform: rotate(-45deg)
  }
  &:after {
    transform: rotate(45deg)
  }
}

.mobile-building-texts {
  width: 100%;
  position: fixed;
  top: 100vh;
  left: 0;
  z-index: 900;
  background-color: transparent;
  .building-text {
    text-align: center;
    position: absolute;
    bottom: 1rem;
    padding: 0 2rem;
    width: 100%;
    h1 {
      font-size: 1.4rem;
      text-transform: uppercase;
      margin-bottom: .5rem;
    }
    p {
      margin-bottom: .5rem;
    }
    a {
      display: inline-block;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 0.9rem;
      color: #082e3c;
      padding: .5rem 2rem;
      border: 2px solid #082e3c;
      transition: border-color .15s ease;
      backface-visibility: hidden;
      margin-top: .5rem;
    }
  }
}

.bg-clouds {
  width: 100%;
  [class^="cloud_"] {
    width: 90px;
    position: absolute;
    >svg {
      fill: rgba(255, 255, 255, .12);
    }
    &:nth-child(1) {
      width: 320px;
      top: 270px;
    }
    &:nth-child(2) {
      width: 240px;
      top: 172px;
      left: 57%;
      transform: rotateY(180deg);
      >svg {
        fill: rgba(255, 255, 255, .2);
      }
    }
    &:nth-child(3) {
      width: 270px;
      right: 2%;
      top: 300px;
    }
    @media screen and (max-width: 480px) {
      &:nth-child(1) {
        width: 60px;
        top: 270px;
      }
      &:nth-child(2) {
        width: 80px;
        top: 172px;
        transform: rotateY(180deg);
        >svg {
          fill: rgba(255, 255, 255, .2);
        }
      }
      &:nth-child(3) {
        width: 85px;
        top: 300px;
      }
    }
  }
}

.bg-gradient {
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: 200;
  top: 0;
  left: 0;
  background-size: 100%;
  @media screen and (max-width: 768px) {
    height: 100%;
  }
}

.bg-clouds {
  position: absolute;
  z-index: 300;
  top: 0;
}

.building-desc {
  width: 590px;
  position: absolute;
  z-index: 4;
  @media screen and (max-width: 768px) {
    display: none;
    opacity: 0;
    visibility: hidden;
  }
  h1 {
    font-size: 3rem;
    text-transform: uppercase;
    margin-bottom: .7rem;
  }
  p {
    font-weight: normal;
    margin-bottom: .9rem;
  }
  a {
    display: inline-block;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 1.1rem;
    color: #082e3c;
    padding: .8rem 5rem;
    border: 2px solid #082e3c;
    transition: border-color .15s ease;
    backface-visibility: hidden;
    &:hover {
      border-color: #ff5c26;
    }
  }
}

.tl-animated-elements {
  position: absolute;
  @media screen and (max-width: 768px) {
    opacity: 0;
    visibility: hidden;
    width: 0;
    height: 0;
    overflow: hidden;
  }
  > .ug-led {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background-color: #dafc51;
    position: absolute;
    &:nth-of-type(1) {
      top: 525px;
      left: -124px;
    }
    &:nth-of-type(2) {
      top: 533px;
      left: -124px;
    }
    &:nth-of-type(3) {
      top: 541px;
      left: -124px;
    }
    &:nth-of-type(4) {
      top: 527px;
      left: -100px;
      background-color: orange;
    }
    &:nth-of-type(5) {
      top: 536px;
      left: -100px;
      background-color: orange;
    }
    &:nth-of-type(6) {
      top: 544px;
      left: -100px;
      background-color: #dafc51;
    }
    &:nth-of-type(7) {
      top: 529px;
      left: -73px;
    }
    &:nth-of-type(8) {
      top: 537px;
      left: -73px;
    }
    &:nth-of-type(9) {
      top: 545px;
      left: -73px;
    }
  }
  > .lamp {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    position: absolute;
    &.yellow {
      top: 266px;
      left: 120px;
      background-color: #FFE91D;
      border: 1px solid #FFF599;
      box-shadow: 0px 0px 22px 6px #fee552;
    }
    &.green {
      top: 260px;
      left: 110px;
      background-color: #96FF00;
      border: 1px solid #C8FF5F;
      box-shadow: 0px 0px 22px 6px #C8FF5F;
    }
    &.green_2 {
      top: 270px;
      left: 141px;
      background-color: #96FF00;
      border: 1px solid #C8FF5F;
      box-shadow: 0px 0px 22px 6px #C8FF5F;
    }
    &.red {
      top: 268px;
      left: 100px;
      background-color: #FF0025;
      border: 1px solid #FF6170;
      box-shadow: 0px 0px 22px 6px #FF6170;
    }
    &.blue {
      top: 261px;
      left: 132px;
      background-color: #00BDFF;
      border: 1px solid #5AE8FF;
      box-shadow: 0px 0px 22px 6px #5AE8FF;
    }
  }
  > .beam {
    width: 50px;
    height: 262px;
    position: absolute;
    background-size: 100%;
    transform-origin: 50% 100%;
    &.blue {
      top: 12px;
      left: 70px;
      transform: rotate(-60deg);
      background-image: url('../.././assets/beam-blue.png');
    }
    &.red {
      top: 10px;
      left: 80px;
      transform: rotate(25deg);
      background-image: url('../.././assets/beam-pink.png');
    }
    &.yellow {
      top: 14px;
      left: 110px;
      transform: rotate(60deg);
      background-image: url('../.././assets/beam-yellow.png');
    }
    &.green {
      top: 14px;
      left: 120px;
      transform: rotate(-40deg);
      background-image: url('../.././assets/beam-green.png');
    }
  }
  > .wave {
    position: absolute;
    background-size: 100%;
    background-repeat: no-repeat;
    &:nth-child(1) {
      width: 43px;
      height: 55px;
      top: -18px;
      left: 20px;
      background-image: url('../.././assets/wave-s.png');
    }
    &:nth-child(2) {
      width: 63px;
      height: 76px;
      top: -45px;
      left: -8px;
      background-image: url('../.././assets/wave-m.png');
    }
    &:nth-child(3) {
      width: 81px;
      height: 101px;
      top: -68px;
      left: -35px;
      background-image: url('../.././assets/wave-l.png');
    }
  }
  > .crane-hook {
    width: 2px;
    height: 5px;
    position: absolute;
    top: 268px;
    left: 166px;
    background-color: #727272;
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 50%;
      transform: translateX(-40%);
      top: 99%;
      width: 10px;
      height: 21px;
      background-image: url('../.././assets/crane-hook.png');
      background-size: 100%;
      background-repeat: no-repeat;
    }
  }
  > .worker {
    width: 4px;
    height: 8px;
    background-size: 100%;
    background-repeat: no-repeat;
    position: absolute;
    &.scaffolding-lower-1 {
      top: 390px;
      left: 178px;
      background-image: url('../.././assets/worker-scaff-1.png');
    }
    &.scaffolding-lower-2 {
      top: 388px;
      left: 167px;
      background-image: url('../.././assets/worker-scaff-2.png');
    }
    &.crane-1 {
      top: 380px;
      left: 100px;
      background-image: url('../.././assets/worker-crane-1.png');
    }
    &.crane-2 {
      top: 340px;
      left: 169px;
      background-image: url('../.././assets/worker-crane-1.png');
    }
  }
}
.tiny-dot-matrix.geek-dotmatrix {
  position: absolute;
  top: 100px;
  left: 31px;
  transform: skew(-5deg) rotate(-5deg);
  > .dot {
    box-shadow: 0px 0px 1px 0px #88ebef;
  }
}

.bridge-ppl {
  position: absolute;
  top: 207px;
  z-index: 2;
  width: 178px;
  height: 20px;
  overflow: hidden;
  .el-img {
    left: -20px;
    position: absolute;
    width: 9px;
  }
}

.buildings {
  .building {
    position: absolute;
    background-size: 100%;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(0, 0, 0, .1);
    background-repeat: no-repeat;
    > .building-overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background-size: 100%;
      z-index: 4;
    }
    &.party {
      width: 389/2+px;
      height: 901/2+px;
      top: -217px;
      left: 110px;
      z-index: 3;
      @media screen and (max-width: 768px) {
        width: 20%;
        height: 87%;
        top: -39%;
        left: 10%;
      }
      > .building-desc {
        padding-left: 50px;
        left: 194px;
        top: 90px;
      }
    }
    &.geek {
      width: 339/2+px;
      height: 947/2+px;
      left: 395px;
      top: -234px;
      z-index: 2;
      @media screen and (max-width: 768px) {
        width: 18%;
        height: 102%;
        top: -46%;
        left: 41%;
      }
      > .building-desc {
        left: 160px;
        top: 106px;
        padding-left: 30px;
        @media screen and (max-width: 1024px) {
          width: 400px;
          top: 56px;
        }
      }
    }
    &.relation {
      width: 674/2+px;
      height: 959/2+px;
      top: -241px;
      left: 515px;
      z-index: 1;
      @media screen and (max-width: 768px) {
        width: 32%;
        height: 87%;
        top: -36%;
        left: 56%;
      }
      &.is-active {
        z-index: 4;
      }
      > .building-desc {
        width: 530px;
        right: 190px;
        top: 106px;
      }
    }
  }
}

.relation-bridge {
  position: absolute;
  width: 178px;
  top: 205px;
  right: 159px;
  @media screen and (max-width: 768px) {
    width: 62%;
    right: 46%;
    top: 35%;
  }
}
.bridge-bg, .bridge-fg {
  width: 100%;
  position: absolute;
}
.bridge-bg {
  z-index: 1;
}
.bridge-fg {
  z-index: 3;
}
.fg-img, .bg-img {
  width: 100%;
  padding-bottom: 30%;
  background-size: 100%;
  background-repeat: no-repeat;
}

.window {
  width: 7px;
  height: 7px;
  position: absolute;
  border-radius: 7px;
  background-color: #fdd000;
  top: 210px;
  left: 192px;
  + .window {
    top: 210px;
    left: 192px;
    + .window {
      top: 347px;
      left: 192px;
      + .window {
        top: 311px;
        left: 192px;
      }
    }
  }
}

.city-header {
  top: 150px;
  position: absolute;
  z-index: 400;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: center;
  @media screen and (max-width: 768px) {
    top: 118px;
  }
  h4 {
    color: $orange;
    font-size: 3.7rem;
    line-height: 1;
    margin-left: .5rem;
    font-family: 'angelique_roseregular';
  }
  h1 {
    text-transform: uppercase;
    font-size: 6rem;
    font-weight: 200;
    line-height: 1;
    font-family: "Gotham Rounded SSm A", "Gotham Rounded SSm B";
    margin-top: -1rem;
    text-indent: -0.35rem;
    > strong {
      font-weight: 700;
    }
  }
  @media screen and (max-width: 768px) {
    h4 {
      font-size: 2rem;
    }
    h1 {
      font-size: 2.8rem;
      margin-top: -.5rem;
    }
  }
  @media screen and (max-width: 480px) {
    h4 {
      font-size: 1.8rem;
      margin-left: -.5rem;
    }
    h1 {
      font-size: 2.2rem;
      margin-top: -.5rem;
    }
  }
}

.city {
  width: 100%;
  position: relative;
  z-index: 500;
  left: 0;
  top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (max-width: 768px) {
    top: 60px;
  }
  @media screen and (max-width: 568px) {
    top: 20px;
  }
}

.city-bg,
.city-overlay {
  width: 100%;
  padding-bottom: 54.8148%;
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center bottom;
}
.city-overlay {
  position: absolute;
  top: 0;
}

.city-inner {
  width: 945px;
  position: relative;
  @media screen and (max-width: 768px) {
    width: 80%;
  }
}
.plane {
  position: absolute;
  width: 374/2+px;
  height: 189/2+px;
  background-size: 100%;
  top: 80px;
  left: 110%;
  z-index: 800;
  .banner {
    height: 29px;
    position: absolute;
    left: 115%;
    top: 39px;
    &:before {
      content: "";
      display: block;
      height: 2px;
      width: 52px;
      position: absolute;
      left: -62px;
      background-color: black;
      top: 15px;
      z-index: 4;
    }
    > div {
      background-size: 100% 30px;
    }
    .left {
      width: 16px;
      height: 31px;
      position: absolute;
      left: -16px;
      background-image: url('../.././assets/banner-left.png');
      background-repeat: no-repeat;
    }
    .middle {
      height: 31px;
      padding: 0 10px;
      white-space: pre;
      line-height: 1.8rem;
      background-image: url('../.././assets/banner-middle.png');
      background-repeat: repeat-x;
    }
    .tail {
      width: 29px;
      height: 31px;
      position: absolute;
      top: 0;
      right: -29px;
      background-image: url('../.././assets/banner-tail.png');
      background-repeat: no-repeat;
    }
  }
  @media screen and (max-width: 1024px) {
    display: none;
  }
}

.tiny-dot-matrix.tower-display {
  transform: skew(-5deg) rotate(-5deg);
  top: 104px;
  left: 33px;
  position: absolute;
}
.tiny-dot-matrix.tower-display .dot {
  box-shadow: none;
}
.tower-display {
  transform: skew(-5deg) rotate(-5deg);
  position: absolute;
  width: 90px;
  height: 38px;
  overflow: hidden;
  top: 100px;
  left: 20px;
  @media screen and (max-width: 1024px) {
    display: none;
  }
  > img {
    left: 100px;
    width: 606px;
    position: absolute;
    max-width: 606px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sections/City.vue